import React from 'react';
import BtnWrap from './BtnWrap';

const BtnWithIconAndText = props => {
  return (
    <div className = {`BtnWidthIcon ${props.className}`}>
      <BtnWrap to = {props.to} download = {props.download} hash ={props.hash} >
        <p>{props.text}</p>
        <img src={props.icon} alt='icon'/>
      </BtnWrap>
    </div>
  );
}

export default BtnWithIconAndText;